module.exports = __webpack_public_path__ + "img/projects_blue.2134aef1.svg";